export const OPENED = 'modal/open'
export const CLOSED = 'modal/close'

const initialState = {
  open: false,

  title:        null,
  message:      null,
  confirmation: null,

  acceptButtonText: null,
  rejectButtonText: null,

  showDateRangePicker: false,

  disableAcceptButton: false,
  disableCancelButton: false,
  alwaysShowCloseButton: false,

  modifiers: [],

  onAccept:          null,
  onReject:          null,
  onDateRangeChange: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case OPENED:
      return {
        ...state,
        open: true,

        title:        action.title,
        message:      action.message,
        confirmation: action.confirmation,

        acceptButtonText: action.acceptButtonText,
        rejectButtonText: action.rejectButtonText,

        showDateRangePicker: action.showDateRangePicker,

        disableAcceptButton: action.disableAcceptButton,
        disableCancelButton: action.disableCancelButton,
        alwaysShowCloseButton: action.alwaysShowCloseButton,

        modifiers: action.modifiers,

        onAccept:          action.onAccept,
        onReject:          action.onReject,
        onDateRangeChange: action.onDateRangeChange
      }

    case CLOSED:
      return initialState

    default:
      return state
  }
}

export const openModal = (opts = {}) => (dispatch) => {
  dispatch({
    type: OPENED,

    title:        opts.title,
    message:      opts.message,
    confirmation: opts.confirmation,

    acceptButtonText: opts.acceptButtonText,
    rejectButtonText: opts.rejectButtonText,

    showDateRangePicker: opts.showDateRangePicker,

    disableAcceptButton: opts.disableAcceptButton,
    disableCancelButton: opts.disableCancelButton,
    alwaysShowCloseButton: opts.alwaysShowCloseButton,

    modifiers: opts.modifiers,

    onAccept:          opts.onAccept,
    onReject:          opts.onReject,
    onDateRangeChange: opts.onDateRangeChange
  })
}

export const closeModal = () => (dispatch) => {
  dispatch({
    type: CLOSED
  })
}
